import { useFormContext, useFormState } from "react-hook-form";
import FormCheckbox from "../../shared/FormCheckbox";
import FormInputText from "../../shared/FormInputText";
import FormSelect from "../../shared/FormSelect";

const UDTs = 'udts';

const step = 5;
const TopAccountStepFive = ({ activeStep }) => {
    const { control, register, getValues } = useFormContext();
    const { errors } = useFormState({ control });

    if (activeStep !== step) return null;

    return (
        <div style={{ width: "50%" }}>
            <p className="sub-title">*Note: UDTs are optional. However, if you choose to add a UDT, you must fill out all of its attributes.</p>
            <br />
            <FormCheckbox
                label={'Invoice Information'}
                name={`${UDTs}.enableInvoiceInformation`}
                control={control}
            />
            {getValues(`${UDTs}.enableInvoiceInformation`) && (
                <>
                    <br />
                    <FormSelect
                        label={'Invoice Type'}
                        name={`${UDTs}.invoiceType`}
                        control={control}
                        options={[
                            { label: 'Basic', value: 'Basic' },
                            { label: 'Detailed', value: 'Detailed' },
                            { label: 'Self-Bill', value: 'Self-Bill' },
                        ]}
                        errors={errors}
                        placeholder="Invoice Type"
                    />
                    <FormSelect
                        label={'Payment Remit Information'}
                        name={`${UDTs}.paymentRemit`}
                        control={control}
                        options={[
                            { label: 'Debit: 1st of month', value: 'Debit: 1st of month' },
                            { label: 'Debit: 10th of month', value: 'Debit: 10th of month' },
                            { label: 'Debit: Client Approval', value: 'Debit: Client Approval' },
                            { label: 'Send Payment: ACH', value: 'Send Payment: ACH' },
                            { label: 'Send Payment: Mail', value: 'Send Payment: Mail' },
                        ]}
                        errors={errors}
                        placeholder="Payment Remit"
                    />
                    <FormInputText
                        label={'Purchase Order'}
                        register={register}
                        name={`${UDTs}.purchaseOrder`}
                        errors={errors}
                        placeholder="Purchase Order"
                    />
                </>
            )}
            <FormCheckbox
                label={'Funding Mode'}
                name={`${UDTs}.enableFundingMode`}
                control={control}
            />
            {getValues(`${UDTs}.enableFundingMode`) && (
                <>
                    <br />
                    <FormSelect
                        label={'Funding Mode'}
                        name={`${UDTs}.fundingMode`}
                        control={control}
                        options={[
                            { label: 'Level-Funded', value: 'Level-Funded' },
                            { label: 'Self-Funded', value: 'Self-Funded' },
                        ]}
                        errors={errors}
                        placeholder="Funding Mode"
                    />
                </>
            )}
            <FormCheckbox
                label={'Account Migration Date'}
                name={`${UDTs}.enableAccountMigrationDate`}
                control={control}
            />
            {getValues(`${UDTs}.enableAccountMigrationDate`) && (
                <>
                    <br />
                    <div className="form-input">
                        <label>Account Migration Date</label>
                        <input
                            {...register(`${UDTs}.accountMigrationDate`)}
                            name={`${UDTs}.accountMigrationDate`}
                            style={{ padding: ".8rem", height: '48px' }}
                            type={"date"}
                            placeholder="Migration date"
                            autoComplete="off"
                        />
                        {errors.udts?.accountMigrationDate && (
                            <p className="danger" style={{ color: "var(--red)", paddingTop: ".4rem" }}>
                                {errors.udts.accountMigrationDate.message}
                            </p>
                        )}
                    </div>
                </>
            )}
            <FormCheckbox
                label={'New York State HCRA Election'}
                name={`${UDTs}.enableNysHcra`}
                control={control}
            />
            {getValues(`${UDTs}.enableNysHcra`) && (
                <>
                    <br />
                    <FormSelect
                        label={'New York State HCRA Election'}
                        name={`${UDTs}.nysHcra`}
                        control={control}
                        options={[
                            { label: 'Elect', value: 'Elect' },
                            { label: 'Non-Elect', value: 'Non-Elect' },
                        ]}
                        errors={errors}
                        placeholder="Election Type"
                    />
                    <div className="form-input">
                        <label>New York State HCRA Election Date</label>
                        <input
                            {...register(`${UDTs}.nysHcraDate`)}
                            name={`${UDTs}.nysHcraDate`}
                            style={{ padding: ".8rem", height: '48px' }}
                            type={"date"}
                            placeholder="Election date"
                            autoComplete="off"
                        />
                        {errors.udts?.nysHcraDate && (
                            <p className="danger" style={{ color: "var(--red)", paddingTop: ".4rem" }}>
                                {errors.udts.nysHcraDate.message}
                            </p>
                        )}
                    </div>

                    <FormInputText
                        label={'New York State HCRA Election Notes'}
                        register={register}
                        name={`${UDTs}.nysHcraNotes`}
                        errors={errors}
                        placeholder="Notes"
                    />
                </>
            )}
            <FormCheckbox
                label={'Risk Sharing'}
                name={`${UDTs}.enableRiskSharing`}
                control={control}
            />
            {getValues(`${UDTs}.enableRiskSharing`) && (
                <>
                    <br />
                    <FormSelect
                        label={'Risk Sharing'}
                        name={`${UDTs}.riskSharing`}
                        control={control}
                        options={[
                            { label: 'No', value: 'No' },
                            { label: 'Yes', value: 'Yes' },
                        ]}
                        errors={errors}
                        placeholder="Enable Risk Sharing?"
                    />
                </>
            )}
            <FormCheckbox
                label={'Channel Partner'}
                name={`${UDTs}.enableChannelPartner`}
                control={control}
            />
            {getValues(`${UDTs}.enableChannelPartner`) && (
                <>
                    <br />
                    <FormSelect
                        label={'Channel Partner'}
                        name={`${UDTs}.channelPartner`}
                        control={control}
                        options={[
                            { label: 'BHCG', value: 'BHCG' },
                        ]}
                        errors={errors}
                        placeholder="Channel Partner"
                    />
                </>
            )}
        </div>
    );
};

export default TopAccountStepFive;
